import { Component, OnInit, Input } from "@angular/core";
import { CompanyDataService } from "../company-data.service";
import {
  TearSheetDataResponse,
  TearSheetErrorResponse,
} from "../company-page.model";
import { Observable } from "rxjs";
import { AppService } from "src/app/app.service";
import {
  VAIconRegistryService,
  download,
  exclamationTriangle,
} from "@va/core-library/icons";

@Component({
  selector: "app-company-tear-sheet",
  templateUrl: "./company-tear-sheet.component.html",
  styleUrls: ["./company-tear-sheet.component.scss"],
})
export class CompanyTearSheetComponent implements OnInit {
  @Input() company: string;
  @Input() disableDownload: boolean;
  tearSheetData: Array<any> = [];
  loading = true;
  dataObservable: Observable<TearSheetDataResponse | TearSheetErrorResponse>;
  constructor(
    private dataService: CompanyDataService,
    private appService: AppService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.iconRegistry.registerIcons([exclamationTriangle, download]);
  }
  ngOnInit() {
    this.dataObservable = this.dataService.getTearSheetData(this.company);
  }

  tearsheetDownload(data) {
    if (data.showDownload && this.disableDownload !== true) {
      data.ticker = this.company;
      this.callTearSheetDownload(data);
    }
  }

  callTearSheetDownload(data) {
    let privateIPOfUser = "";
    try {
      this.appService.getUserIP((ip) => {
        privateIPOfUser = ip;
      });
    } catch (err) {
      privateIPOfUser = "";
    }
    const tearSheetComp = data.ticker;
    const focus = data.focus;
    let tearurlParams = `ticker=${tearSheetComp}&type=${data.type}&source=${data.source}&tabid=${window.b_tab}&userIP=${privateIPOfUser}`;
    if (focus) {
      tearurlParams += `&focus=${focus}`;
    }
    this.dataService.downloadTearSheet(tearurlParams).subscribe();
  }

  retry() {
    this.dataObservable = this.dataService.getTearSheetData(this.company);
  }

  onTearsheetDataResolved(respObject: TearSheetDataResponse) {
    this.tearSheetData = [
      {
        row: [
          {
            item: "Earnings Preview (Consensus and Per Broker Data)",
            focus: respObject.tear_sheet_data.first_estimated_fiscal,
            type: "pre",
            source: "all",
            showDownload: true,
          },
          {
            item: "Earnings Preview (Consensus only)",
            focus: respObject.tear_sheet_data.first_estimated_fiscal,
            type: "pre",
            source: "consensus",
            showDownload: true,
          },
          {
            item: "Earnings Review And Surprise Analysis (Consensus and Per Broker Data)",
            focus: respObject.tear_sheet_data.last_actual_fiscal,
            type: "post",
            source: "all",
            showDownload: true,
          },
          {
            item: "Earnings Review And Surprise Analysis (Consensus only)",
            focus: respObject.tear_sheet_data.last_actual_fiscal,
            type: "post",
            source: "consensus",
            showDownload: true,
          },
        ],
      },
    ];
  }
}
